// extracted by mini-css-extract-plugin
export default {"container":"Uk-z","blurb":"Vk-z","links":"Wk-z"};